import {FC, useState, useEffect} from 'react'
import TypeProposalDocument from './TypeProposalDocument'

import {OverlayTrigger, Tooltip} from 'react-bootstrap'
type Props = {
  data: any
  selectedIndicators: any
  onSelectIndicator: (id: string, value: number, bobot: any) => void
}

const IndicatorRadioContent: FC<Props> = ({data, selectedIndicators, onSelectIndicator}) => {
  return (
    <div className='d-flex justify-content-between my-5'>
      {/* KIRI */}
      <div className='d-flex align-items-start'>
        <p>{data?.nama}</p>
      </div>

      {/* KANAN */}
      <div className='d-flex align-items-center custom-radio'>
        {[1, 2, 3, 4].map((val) => (
          <OverlayTrigger
            key={val}
            placement='top'
            overlay={<Tooltip>{data[`tooltip_${val}`]}</Tooltip>}
          >
            <div className='form-check me-4'>
              <input
                className='form-check-input custom-radio-input'
                type='radio'
                onChange={() => onSelectIndicator(data.id, val, data?.bobot)}
                name={data.id}
                value={val}
                checked={selectedIndicators?.[data.id] == val}
              />
              <label className='form-check-label'>{val == 3 ? 4 : val == 4 ? 5 : val}</label>
            </div>
          </OverlayTrigger>
        ))}
      </div>
    </div>
  )
}

const IndicatorRadio: FC<Props> = ({data, selectedIndicators, onSelectIndicator}) => {
  return (
    <IndicatorRadioContent
      data={data}
      selectedIndicators={selectedIndicators}
      onSelectIndicator={onSelectIndicator}
    />
  )
}

export default IndicatorRadio
